"use client";

import Link from "next/link";
import { useState } from "react";
import { useRouter } from "next/navigation";
import { Shield, Eye, EyeOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/lib/store";

export default function LoginPage() {
  const [email, setEmail] = useState("jean.dupont@dupont-sas.fr");
  const [password, setPassword] = useState("••••••••");
  const [showPwd, setShowPwd] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const router = useRouter();

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!email || !password) { 
      setError("Veuillez remplir tous les champs."); 
      return; 
    }

    setLoading(true);
    setError("");

    await new Promise((r) => setTimeout(r, 800));

    console.log("Before login");
    login(email);
    console.log("localStorage:", localStorage.getItem("shield_auth"));
    console.log("Before push");
    router.push("/app/dashboard");
    console.log("After push");
  }

  return (
    <div className="flex min-h-full items-center justify-center bg-surface-secondary px-4 py-12">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex flex-col items-center gap-2">
          <Link href="/" className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand-600">
            <Shield className="h-5 w-5 text-white" />
          </Link>
          <h1 className="text-xl font-bold text-text-primary">Connexion à Shield</h1>
          <p className="text-sm text-text-secondary">Bienvenue, connectez-vous à votre espace.</p>
        </div>

        <div className="rounded-xl border border-border bg-surface p-6 shadow-card">
          {error && (
            <div className="mb-4 rounded-lg bg-danger-light px-3 py-2 text-sm text-danger">
              {error}
            </div>
          )}

          {/* Demo hint */}
          <div className="mb-4 rounded-lg bg-brand-50 border border-brand-200 px-3 py-2">
            <p className="text-xs text-brand-700">
              <strong>Démo :</strong> entrez n&apos;importe quel e-mail et mot de passe pour accéder.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <Input
              label="Adresse e-mail"
              type="email"
              placeholder="vous@entreprise.fr"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <div className="flex flex-col gap-1.5">
              <label className="text-sm font-medium text-text-primary">Mot de passe</label>
              <div className="relative">
                <input
                  type={showPwd ? "text" : "password"}
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="h-9 w-full rounded border border-border bg-surface px-3 pr-9 py-2 text-sm text-text-primary placeholder:text-text-muted focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-brand-500"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPwd(!showPwd)}
                  className="absolute right-2 top-1/2 -translate-y-1/2 text-text-muted hover:text-text-secondary"
                >
                  {showPwd ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                </button>
              </div>
            </div>

            <div className="flex justify-end">
              <Link href="/reset-password" className="text-xs text-brand-600 hover:underline">
                Mot de passe oublié ?
              </Link>
            </div>

            <Button type="submit" className="w-full mt-1" loading={loading}>
              Se connecter
            </Button>
          </form>
        </div>

        <p className="mt-5 text-center text-sm text-text-secondary">
          Pas encore de compte ?{" "}
          <Link href="/signup" className="font-medium text-brand-600 hover:underline">
            S&apos;inscrire
          </Link>
        </p>
      </div>
    </div>
  );
}
